module.exports = __webpack_public_path__ + "assets/b_diners-club-89d0d9.svg";